import { render, staticRenderFns } from "./UiLineClamp.vue?vue&type=template&id=537babe0&"
import script from "./UiLineClamp.vue?vue&type=script&lang=ts&"
export * from "./UiLineClamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports